// import React, { useState, useEffect } from "react";
// import { countries } from "../../../_constants/staticData";
// import VideoIFrame from "./VideoPreview";

// export const InstructorInfo = ({ formState, handleChange, trasnlate }) => {
//   const [preview, setPreview] = useState(false);
//   const [showPreviewButton, setShowPreviewButton] = useState(false);
//   const [showClosePreview, setShowClosePreview] = useState(false);

//   const handleIntroductionLinkChange = (e) => {
//     handleChange(e);
//     let regVimeo = /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/;
//     let regYouTube =
//       /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
//     let result = e.target.value.includes("vimeo")
//       ? regVimeo.test(e.target.value)
//       : regYouTube.test(e.target.value);
//     if (result) {
//       setShowPreviewButton(true);
//     } else {
//       setShowPreviewButton(false);
//       setShowClosePreview(false);
//     }
//     setPreview(false);
//   };

//   const handlePreview = () => {
//     setPreview(true);
//     setShowClosePreview(true);
//   };

//   const handleClose = () => {
//     setPreview(false);
//     setShowClosePreview(false);
//   };

//   return (
//     <>
//       {/* <div className="align-title social">
//         <h3>
//           MORE INFORMATION <span>(Optional) Visible on Public Profile</span>
//         </h3>
//       </div>
//       <div className="flex-wrapper">
//         <div className="flex-left">
//           <input
//             type="text"
//             placeholder={trasnlate(
//               "Languages i.e. English, German, and Japanese"
//             )}
//             name="languages"
//             value={formState.languages || ""}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="flex-right">
//           <input
//             type="text"
//             placeholder={trasnlate("Youtube URL")}
//             name="youtubeProfile"
//             value={formState.youtubeProfile || ""}
//             onChange={handleChange}
//           />
//         </div>
//       </div> */}
//       <Accordian title="ADD LOCATION">
//         <div className="flex-wrapper">
//           <div className="flex-left">
//             <input
//               type="text"
//               placeholder={trasnlate("City/Town, State")}
//               name="publicLocation"
//               value={formState.publicLocation || ""}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="flex-right">
//             <div className="styled-select">
//               <select name="publicLocationCountry" onChange={handleChange}>
//                 <option value="">Select Country</option>
//                 {countries.map((country, index) => (
//                   <option
//                     value={country.name}
//                     selected={country.name === formState.publicLocationCountry}
//                     key={index}
//                   >
//                     {country.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>
//       </Accordian>
//       <Accordian title="ADD TEXT INTRODUCTION">
//         <div className="flex-wrapper">
//           <textarea
//             name="introduction"
//             onChange={handleChange}
//             value={formState.introduction}
//           ></textarea>
//         </div>
//       </Accordian>
//       <Accordian title="ADD YOUTUBE INTRODUCTION LINK">
//         <div className="flex-wrapper">
//           <input
//             type="text"
//             name="introductionLink"
//             placeholder={trasnlate("Add Introduction Link")}
//             onChange={handleIntroductionLinkChange}
//             value={formState.introductionLink}
//             className="youTubeLinkInput"
//           ></input>
//         </div>
//         <div className="videoPreviewContainer">
//           {showPreviewButton && (
//             <button
//               type="button"
//               className="btn-submit"
//               onClick={handlePreview}
//             >
//               Preview
//             </button>
//           )}
//           {showClosePreview && (
//             <button
//               type="button"
//               className="btn-submit btn-preview-close"
//               onClick={handleClose}
//             >
//               Close
//             </button>
//           )}
//           {preview && <VideoIFrame url={formState.introductionLink} />}
//         </div>
//       </Accordian>
//       <Accordian title="ADD PROFESSIONAL QUALIFICATIONS">
//         <div className="flex-wrapper">
//           <textarea
//             type="text"
//             name="qualifications"
//             placeholder={trasnlate("Add Professional Qualifications")}
//             onChange={handleChange}
//             value={formState.qualifications}
//           ></textarea>
//         </div>
//       </Accordian>
//       <Accordian title="ADD AWARDS, ACHIEVEMENTS, CERTIFICATIONS">
//         <div className="flex-wrapper">
//           <textarea
//             type="text"
//             name="certifications"
//             placeholder={trasnlate("Add Awards, Achievements, certifications")}
//             onChange={handleChange}
//             value={formState.certifications}
//           ></textarea>
//         </div>
//       </Accordian>
//     </>
//   );
// };

// const Accordian = ({ title, style, children }) => {
//   const [isActive, setIsActive] = useState(false);
//   return (
//     <div className="additional-info">
//       <div className="plus" onClick={() => setIsActive((state) => !state)}>
//         {title}
//       </div>
//       {isActive && children}
//     </div>
//   );
// };



import React, { useState, useEffect } from "react";
import { countries } from "../../../_constants/staticData";
import VideoIFrame from "./VideoPreview";
import axiosInstance from "../../../axios";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export const InstructorInfo = ({ formState, handleChange, trasnlate }) => {
  //console.log("formState", formState);

  const [preview, setPreview] = useState(false);
  const [showPreviewButton, setShowPreviewButton] = useState(false);
  const [showClosePreview, setShowClosePreview] = useState(false);
  const [courses, setCourses] = useState([]);

  const selectedCourses = React.useMemo(() => {
    if (typeof formState.introduction === "string") {
      try {
        return JSON.parse(formState.introduction);
      } catch (err) {
        return [];
      }
    }
    return Array.isArray(formState.introduction) ? formState.introduction : [];
  }, [formState.introduction]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/course`);
        setCourses(res?.data?.data?.data || []);
        //console.log("courses", res);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, []);


  const handleIntroductionLinkChange = (e) => {
    handleChange(e);
    const value = e.target.value;
    const regVimeo = /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/;
    const regYouTube =
      /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    const isValid = value.includes("vimeo")
      ? regVimeo.test(value)
      : regYouTube.test(value);

    setShowPreviewButton(isValid);
    setShowClosePreview(false);
    setPreview(false);
  };

  const handlePreview = () => {
    setPreview(true);
    setShowClosePreview(true);
  };

  const handleClose = () => {
    setPreview(false);
    setShowClosePreview(false);
  };

  return (
    <>
      <Accordian title="ADD LOCATION">
        <div className="flex-wrapper">
          <div className="flex-left">
            <input
              type="text"
              placeholder={trasnlate("City/Town, State")}
              name="publicLocation"
              value={formState.publicLocation || ""}
              onChange={handleChange}
            />
          </div>

          <div className="flex-right">
            <div className="styled-select">
              <select
                name="publicLocationCountry"
                onChange={handleChange}
                value={formState.publicLocationCountry || ""}
              >
                <option value="">Select Country</option>
                {countries.map((country, index) => (
                  <option value={country.name} key={index}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </Accordian>

      <Accordian title="SELECT YOUR COURSES">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course, index) => (
            <div
              key={index}
              className="w-[100%] flex items-center h-14 space-x-3 p-3 bg-white rounded-md shadow-sm hover:bg-gray-50 cursor-pointer"
            >
              <div className="w-[20%]">
                <input
                  type="checkbox"
                  id={`course-${index}`}
                  value={course.CourseName}
                  checked={selectedCourses.includes(course.CourseName)}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    let updatedCourses = [...selectedCourses];

                    if (isChecked) {
                      updatedCourses.push(course.CourseName);
                    } else {
                      updatedCourses = updatedCourses.filter(
                        (name) => name !== course.CourseName
                      );
                    }

                    handleChange({
                      target: {
                        name: "introduction",
                        value: updatedCourses,
                      },
                    });
                  }}
                  className="mt-5 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
              </div>
              <p className="w-[80%] text-gray-800 text-sm font-medium">
                {course.CourseName}
              </p>
            </div>
          ))}
        </div>

        {selectedCourses.length > 0 && (
          <div className="mt-6 bg-gray-100 p-4 rounded-md shadow">
            <h4 className="text-lg font-semibold mb-3 text-gray-800">
              Selected Courses:
            </h4>
            <ul className="list-disc list-inside text-gray-700">
              {selectedCourses.map((course, index) => (
                <li key={index}>{course}</li>
              ))}
            </ul>
          </div>
        )}
      </Accordian>

      <Accordian title="ADD YOUTUBE INTRODUCTION LINK">
        <div className="flex-wrapper">
          <input
            type="text"
            name="introductionLink"
            placeholder={trasnlate("Add Introduction Link")}
            onChange={handleIntroductionLinkChange}
            value={formState.introductionLink}
            className="youTubeLinkInput"
          />
        </div>
        <div className="videoPreviewContainer">
          {showPreviewButton && (
            <button
              type="button"
              className="btn-submit"
              onClick={handlePreview}
            >
              Preview
            </button>
          )}
          {showClosePreview && (
            <button
              type="button"
              className="btn-submit btn-preview-close"
              onClick={handleClose}
            >
              Close
            </button>
          )}
          {preview && <VideoIFrame url={formState.introductionLink} />}
        </div>
      </Accordian>

      <Accordian title="ADD PROFESSIONAL QUALIFICATIONS">
        <div className="flex-wrapper">
          <textarea
            type="text"
            name="qualifications"
            placeholder={trasnlate("Add Professional Qualifications")}
            onChange={handleChange}
            value={formState.qualifications}
          />
        </div>
      </Accordian>

      <Accordian title="ADD AWARDS, ACHIEVEMENTS, CERTIFICATIONS">
        <div className="flex-wrapper">
          <textarea
            type="text"
            name="certifications"
            placeholder={trasnlate(
              "Add Awards, Achievements, certifications"
            )}
            onChange={handleChange}
            value={formState.certifications}
          />
        </div>
      </Accordian>
    </>
  );
};

const Accordian = ({ title, style, children }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="additional-info">
      <div
        className="plus cursor-pointer font-semibold text-lg py-2"
        onClick={() => setIsActive((state) => !state)}
      >
        {title}
      </div>
      {isActive && <div className="py-2">{children}</div>}
    </div>
  );
};
